import { useEffect, useState } from 'react';
import type { Theme } from '@fluentui/react-components';
import { darkTheme, lightTheme } from '../theme';

const QUERY = '(prefers-color-scheme: dark)';

/** `?theme=light|dark` in the page URL, which pins the theme (screenshots); otherwise null. */
export function themeOverride(search = window.location.search): 'light' | 'dark' | null {
  const t = new URLSearchParams(search).get('theme');
  return t === 'light' || t === 'dark' ? t : null;
}

/** Light/dark Fluent theme: `?theme=` if given, else the OS setting, tracked live. */
export function useSystemTheme(): Theme {
  // Read once: the router drops the query on navigation, and the pinned theme should stay.
  const [override] = useState(() => themeOverride());
  const [dark, setDark] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    if (override) return;
    const mq = window.matchMedia(QUERY);
    const onChange = (e: MediaQueryListEvent) => setDark(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [override]);
  return (override ? override === 'dark' : dark) ? darkTheme : lightTheme;
}
